import { usePermissions } from '@refinedev/core'
import { Breadcrumb, Table } from 'antd'
import { useNavigate } from 'react-router-dom'

import { hasPermission } from '@/auth/capabilities'

import { providerColumns } from './columns'
import { GlobalMarkupCard } from './components/GlobalMarkupCard'
import { GpuState } from './components/GpuState'
import { useProviderControls } from './components/useProviderControls'
import { type GpuProvider, useGpuProviders } from './hooks/useGpuAdmin'

export default function GpuProvidersListPage() {
  const navigate = useNavigate()
  const { data: permissions = [] } = usePermissions<string[]>({})
  const canWrite = hasPermission(permissions, 'admin:gpu:write')
  const { data, isLoading, error } = useGpuProviders()
  const { controls, markupModal } = useProviderControls()

  return (
    <div>
      <Breadcrumb
        style={{ marginBottom: 16 }}
        items={[{ title: 'GPU' }, { title: 'Providers' }]}
      />
      <GpuState error={error} />
      <GlobalMarkupCard canWrite={canWrite} />
      <Table<GpuProvider>
        rowKey="key"
        dataSource={data}
        columns={providerColumns(canWrite ? controls : undefined)}
        loading={isLoading}
        pagination={false}
        size="small"
        scroll={{ x: 900 }}
        onRow={(provider) => ({
          style: { cursor: 'pointer' },
          onClick: () => void navigate(`/gpu/providers/${provider.key}`),
        })}
      />
      {markupModal}
    </div>
  )
}
